<template>
  <div id="prop-similar" class="prop-similar">
    <h2>Similar properties</h2>
    <div class="grid">
      <div class="card"
           v-for="property in similarProps"
           :key="property.id"
           :id="property.id"
           @click.stop.prevent="goToProp(property.id, property.link)">
        <div class="frame">
          <div class="itm" :style="{ backgroundImage:  'url(' + property.images[0].url + ')'}">
            <img class="img" loading="lazy" :alt="property.name" :src="property.images[0].url"/>
            <div class="booking" v-if="property.laterooms">Partner deal</div>
            <div class="pet" v-if="property.pets" title="This property allows pets">
              <svg class="ico--15">
                <use xlink:href="#ico-pet"/>
              </svg>
            </div>
          </div>
        </div>
        <div class="detail">
          <div class="head">
            <div class="titles">
              <h3 class="name" :title="property.name"> {{ property.name }}</h3>
              <h4 class="region" v-if="property.town"> {{ property.town }}</h4>
            </div>
            <div class="side">
              <div class="sleeps" v-if="property.sleeps">
                Sleeps {{ property.sleeps }}
              </div>
            </div>
            <div class="price">
              {{showPrice(property.id)}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data: function () {
    return {
      priceData:[]
    }
  },
  props: {
    similarProps: {
      type: Array,
      required: true
    },
    checkInDate: String,
    nights: String,
    searchId: String
  },
  methods: {
    getRequest() {
      return {
        method: "GET",
        credentials: "include",
        headers: {
          'X-CSRF-TOKEN': st.getCSRFToken()
        }
      };
    },
    getPrices() {
      let ids = [],
        app = this,
        id = app.$props.searchId,
        props = app.$props.similarProps,
        url;

      for (let i = 0; i < props.length; i++) {
        ids.push(props[i].id);
      }

      url = st.withPrid("/prices.json?properties=" + encodeURIComponent(ids.join(",")) + (id !== "" ? "&search=" + id : ''));

      fetch(url, app.getRequest())
        .then((resp) => resp.json())
        .then(function(pdata) {
          app.priceData = pdata
        });
    },
    showPrice(id) {
      let app = this,
        price = ""
      if (app.priceData.length > 0) {
        app.priceData.forEach(element => {
          if (element.prop_id === id) {
            price = element.discount_price
          }
        })
      }

      if (price !== "") {
        return app.money(price)
      }
    },
    goToProp: function(id, link) {
      let date = this.$props.checkInDate;
      let nights = this.$props.nights;
      let newDate = st.reverseDate(date);
      let hasDate = this.hasVal(date),
        hasNights = this.hasVal(nights);

      let url = !hasDate && !hasNights ? link : link + "?" +
        (hasDate ? "check_in_on=" + newDate : "") +
        (hasDate && hasNights ? "&" : "") +
        (hasNights ? "nights=" + nights : "");

      this.$emit('track', "prop_click", id);

      if (document.body.classList.contains("isIE")) {
        window.location.href = url;
      } else {
        window.open(url, "_blank");
      }
    },
    hasVal(val) {
      return val !== "" && typeof val !== "undefined";
    },
    money(val) {
      return st.money(val);
    }
  },
  mounted: function() {
    this.getPrices();
  }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.prop-similar {
  padding: 0 1.25rem;
  margin-bottom: 1.25rem;

  h2 {
    font-size: 1.25rem;
    line-height: 1.25rem;
  }

  .grid {
    display: flex;
    flex-direction: column;
    grid-gap: .75rem;
    padding-top: .625rem;
  }

  .card {
    height: 9.375rem;
    display: flex;
    padding: 0.75rem;
    box-sizing: border-box;
    width: 100%;
    border-radius: 0.188rem;
    background: $col_offwhite;
    box-shadow: 0 .125rem .25rem $col_white;
    cursor: pointer;

    &:hover {
      box-shadow: 0 .125rem .875rem $col_aqua;
    }
  }

  .frame {
    height: auto;
    width: 35%;
    border-radius: 0.188rem;
    overflow: hidden;
    position: relative;
  }

  .itm {
    min-height: 100%;
    background-size: cover;
    border-radius: 0.188rem;
    background-position: center;
  }

  .booking {
    position: absolute;
    bottom: 0;
    font-size: 0.688rem;
    font-weight: 700;
    line-height: 1.5rem;
    width: 100%;
    color: $col_white;
    background: #003580;
    text-align: center;
  }

  .img {
    display: none;
    width: 100%;
  }

  .pet {
    position: absolute;
    background: $col_aqua;
    border-radius: 100%;
    top: .25rem;
    right: .35rem;
    height: 1.5rem;
    width: 1.5rem;

    svg {
      position: absolute;
      left: 50%;
      top: 50%;
      margin: -.45rem 0 0 -.45rem;
    }
  }

  .maxpet {
    height: 1rem;
    width: 1rem;
    font-size: .688rem;
    line-height: 1rem;
    top: 1.35rem;
    margin-left: -.5rem;
    font-weight: 700;
    left: 50%;
    text-align: center;
    background: $col_white;
    position: absolute;
    border-radius: 100%;
    box-shadow: 0 .125rem .125rem $col_oplightblack;
  }

  .detail {
    padding: 0;
    padding-left: 0.75rem;
    display: flex;
    flex-direction: column;
    width: 55%;
    position: relative;
  }

  .head {
    min-height: 0;
    display: flex;
    flex-direction: column;
  }

  .titles {
    width: 100%;
  }

  .name {
    font-size: 0.875rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .region {
    color: $col_black;
    text-transform: inherit;
    font-size: 0.75rem;
    font-weight: inherit;
  }

  .side {
    display: flex;
    font-size: .75rem;
    padding-top: .25rem;
  }

  .sleeps {
    text-align: left;
    color: $col_deepgrey;
    display: flex;
    align-items: center;

    svg {
      width: 1.25rem;
      margin-right: .25rem;
    }
  }

  .price {
    font-weight: 700;
    font-size: 1.25rem;
    text-align: end;
    position: absolute;
    right: -1rem;
    bottom: 0;
  }

  .name {
    font-weight: 600;
  }

  .foot {
    flex-direction: row-reverse;
    align-items: end;
  }

  .view {
    font-size: .875rem;
    font-weight: 600;
    text-transform: uppercase;
    text-decoration: underline;
  }

  @media #{$l-tablet} {
    .frame {
      width: 40%;
    }

    .grid {
      display: grid;
      grid-template-columns: calc(50% - .5rem) calc(50% - .5rem);
      grid-gap: 1rem;
    }

    .price {
      right: 0;
    }
  }

  @media #{$desktop} {
    padding: 0;

    h2 {
      font-size: 1.5rem;
      line-height: 1.813rem;
    }

    .grid {
      padding-top: 1.25rem;
    }
  }
}
</style>